import { ArrowLeftOutlined, SwapOutlined, UndoOutlined } from '@ant-design/icons';
import { Button, Tabs } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import { RestoreTabContent, TransferTabContent } from 'components/features/backOffice/BackOfficeOperationsDataTransfer';

function BackOfficeOperationsDataTransfer(): JSX.Element {
  const navigate = useNavigate();

  const tabItems = [
    {
      key: 'transfer',
      label: (
        <span>
          <SwapOutlined /> Transfer
        </span>
      ),
      children: <TransferTabContent />
    },
    {
      key: 'restore',
      label: (
        <span>
          <UndoOutlined /> History
        </span>
      ),
      children: <RestoreTabContent />
    }
  ];

  return (
    <PageHeaderPusher>
      <>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/back-office/operations')}
          style={{ padding: 0 }}
        >
          Back to operations
        </Button>
        <Tabs items={tabItems} className="mt-16" />
      </>
    </PageHeaderPusher>
  );
}

export default BackOfficeOperationsDataTransfer;
